export default function EmployeeModifyController(
  $scope,
  $stateParams,
  $state,
  $window,
  $translate,
  roleService,
  roleHelper,
  employeesService,
  UtilService,
  environmentService,
  merchantService,
  NotificationService,
  EMPLOYEES_CONSTANTS,
) {
  const vm = this;

  vm.EMAIL = {
    'error.high.spam.score.email': 'This email has a high spam score. Please try a different one',
    'invalid.email': 'This email is not valid. Please try a different one'
  };
  vm.merchantId = $stateParams.merchantId ? parseInt($stateParams.merchantId, 10) : null;
  vm.employeeId = $stateParams.employeeId ? parseInt($stateParams.employeeId, 10) : null;
  vm.merchant = $stateParams.merchant;
  vm.employeeForm = null;
  vm.roles = [];
  vm.gender = [
    {
      name: 'Male',
      value: 'male',
    },
    {
      name: 'Female',
      value: 'female',
    },
  ];
  vm.isLoading = false;

  vm.employee = {
    id: null,
    role: null,
    gender: null,
    name: null,
    firstName: null,
    pin: null,
    email: null,
    password: null,
  };

  vm.employees = [];
  vm.merchantHasOwner = false;

  vm.isPasswordRequired = false;
  vm.activeTab = 'employees';

  init();

  vm.init = init;
  vm.createEmployee = createEmployee;
  vm.updateEmployee = updateEmployee;
  vm.deleteEmployee = deleteEmployee;

  $scope.$watch('vm.employee.role', function() {
    if (vm.employee.role !== null) {
      vm.isPasswordRequired = !EMPLOYEES_CONSTANTS.HIDE_PASSWORD_FIELD_FOR_ROLES.includes(vm.employee.role.name);
      vm.allowSetPassword = !environmentService.isBetaOrProduction() && vm.isPasswordRequired;
    }
  });

  function init() {
    enableLoading();
    if (!vm.merchant) {
      merchantService.getMerchantById(vm.merchantId).then(function(res) {
        vm.merchant = res.data;
      });
    }
    roleService
      .getRoles()
      .then(initEmployees)
      .finally(disableLoading);
  }

  function initEmployees(resRoles) {
    employeesService.getEmployees(vm.merchantId).then(function(res) {
      vm.employees = res.data.employees;
      vm.merchantHasOwner = vm.employees.some(function(employee) {
        return employee.role && employee.role.name && employee.role.name === EMPLOYEES_CONSTANTS.ROLES.MERCHANT;
      });
      initRoles(resRoles);
    });
  }

  function initRoles(res) {
    angular.forEach(res.data, function(role) {
      let allowRole = true;
      if (EMPLOYEES_CONSTANTS.ROLE_BLACKLIST.indexOf(role.name) > -1) {
        allowRole = false;
      }
      if (vm.merchant && vm.merchant.productIds) {
        angular.forEach(EMPLOYEES_CONSTANTS.ROLE_BLACKLIST_PER_MERCHANT_PRODUCT, function(blacklistedRoles, productId) {
          if (vm.merchant.productIds.indexOf(parseInt(productId, 10)) > -1 && blacklistedRoles.indexOf(role.name) > -1) {
            allowRole = false;
          }
        });
      }
      if ((vm.merchantHasOwner || role.name === EMPLOYEES_CONSTANTS.ROLES.MERCHANT || vm.employeeId) && allowRole) {
        role.label = roleHelper.getLabel(role.name);
        vm.roles.push(role);
      }
    });
    getEmployeeIfEditMode();
  }

  function getEmployeeIfEditMode() {
    if (vm.employeeId) {
      vm.employee = UtilService.findElementById(vm.employees, vm.employeeId);
      if (!vm.employee.role.instanceIds.length) {
        vm.roles.forEach(function(role) {
          if (role.name === vm.employee.role.name) {
            vm.employee.role = role;
          }
        });
      }
    }
  }

  function createEmployee() {
    const employee = getEmployeeForApi();
    if (vm.isLoading) {
      return;
    }
    enableLoading();
    employeesService
      .createEmployee(vm.merchantId, employee)
      .then(function() {
        goToMerchantEmployeeList('Employee added to merchant');
      })
      .catch(function(res) {
        handleError(res, 'Error adding employee');
      })
      .finally(disableLoading);
  }

  function updateEmployee() {
    const employee = getEmployeeForApi();
    if (vm.isLoading || !vm.employeeId) {
      return;
    }
    enableLoading();
    employeesService
      .updateEmployee(vm.merchantId, vm.employeeId, employee)
      .then(function() {
        goToMerchantEmployeeList('Employee updated');
      })
      .catch(function(res) {
        handleError(res, 'Error updating employee');
      })
      .finally(disableLoading);
  }

  function getEmployeeForApi() {
    const employee = angular.copy(vm.employee);
    if (employee.role && employee.role.label) {
      delete employee.role.label;
    }
    return employee;
  }

  function handleError(res, defaultMessage) {
    let output;
    const errorMessages = [];
    const { data } = res;

    if (data) {
      data.errors.forEach(error => {
        const { field, message } = error;

        if (field && vm.employeeForm[field]) {
          vm.employeeForm[field].$invalid = true;
        }
        if (message) {
          const msg = vm.EMAIL[message] ? vm.EMAIL[message] : message;
          errorMessages.push($translate.instant(msg));
        }
      });
    }

    output = errorMessages.length ? errorMessages.join('; ') : defaultMessage;
    NotificationService.error(output);
  }

  function goToMerchantEmployeeList(message) {
    NotificationService.success(message);
    $state.go(
      'app.merchant',
      {
        merchantId: vm.merchantId,
        tab: 'employees',
      },
      { reload: true },
    );
  }

  function deleteEmployee() {
    let confirmation;
    if (vm.isLoading || !vm.employeeId) {
      return;
    }
    confirmation = $window.confirm('Are you sure you want to delete ' + vm.employee.firstName + ' ' + vm.employee.name + '?');
    if (confirmation) {
      enableLoading();
      employeesService
        .deleteEmployee(vm.merchantId, vm.employeeId)
        .then(function() {
          goToMerchantEmployeeList('Employee ' + vm.employee.firstName + ' ' + vm.employee.name + ' deleted');
        })
        .catch(function(res) {
          handleError(res, 'Error deleting employee');
        })
        .finally(disableLoading);
    }
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/employees/employee-modify.controller.js